import { Routes } from "@angular/router";
import { SignInComponent } from "./views/auth/views/sign-in/sign-in.component";
import { SignUpComponent } from "./views/auth/views/sign-up/sign-up.component";
import { AuthGuard } from "./views/auth/guards/auth.guard";
//@ts-ignore
import Application from "@carbon/icons/es/application/32.js";
import { MailOtpComponent } from "./views/auth/views/mail-otp/mail-otp.component";
import { wsResolver } from "./shared/resolvers/ws.resolver";

export const routes: Routes = [
	{
		path: "",
		component: SignInComponent,
		data: {},
	},
	{
		path: "login",
		component: SignInComponent,
	},
	{
		path: "mail-otp",
		component: MailOtpComponent,
	},
	{
		path: "signup",
		component: SignUpComponent,
	},
	{
		path: "demo",
		data: { breadcrumb: "API App Playground", breadcrumbIcon: Application },
		loadChildren: () => import("./views/demo-playground/demo.routing").then((m) => m.routes),
		canActivate: [AuthGuard],
	},
	{
		path: "demo-free",
		data: { breadcrumb: "API App Playground", breadcrumbIcon: Application, noSidebar: true, embedded: true },
		resolve: [wsResolver],
		loadChildren: () => import("./views/demo-playground/demo.routing").then((m) => m.routes),
	},
	{
		path: "dashboard",
		data: { breadcrumb: "Dashboard" },
		loadChildren: () => import("./views/dashboard/dashboard.routing").then((m) => m.routes),
		canActivate: [AuthGuard],
	},
	{
		path: "code-playground",
		data: { breadcrumb: "Code Playground" },
		loadChildren: () => import("./views/code-playground/code-playground.routing").then((m) => m.routes),
		canActivate: [AuthGuard],
	},
];
